module.exports = __webpack_public_path__ + "static/media/Water.2d4c4bdd.png";